import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { FIELD_LENGTH, InputText, ValidationService } from '@sm360/widget-commons-forms';

import LoadingButton from 'login/components/Library/LoadingButton/LoadingButton.jsx';
import PasswordGroup from 'login/components/Library/PasswordGroup/PasswordGroup.jsx';

import { ProfileService, AnalyticsService } from '@sm360/widget-commons-general';

import CONSTANT from 'login/constants/constant.js';
import TAGS from 'login/constants/trackingTags';

class ChangePasswordForm extends React.Component {
    constructor(props) {
        super(props);

        this.handleFormSubmission = this.handleFormSubmission.bind(this);
        this.handleCurrentPasswordChange = this.handleCurrentPasswordChange.bind(this);
        this.passwordChangeCallback = this.passwordChangeCallback.bind(this);
        this.sendForm = this.sendForm.bind(this);

        this.state = {
            formInputs: {
                currentPassword: '',
                newPassword: '',
                newPasswordConfirmation: '',
            },
            formValidation: {
                currentPassword: false,
                newPassword: false,
            },
            errorMessage: '',
            successMessage: '',
            btnEnabled: true,
        };
    }

    handleCurrentPasswordChange(value) {
        const formInputs = this.state.formInputs;
        const formValidation = this.state.formValidation;

        formInputs.currentPassword = value;
        formValidation.currentPassword = ValidationService.validateIsNotEmpty(value);

        this.setState({
            formInputs,
            formValidation,
        });
    }

    passwordChangeCallback(groupResponse) {
        const state = this.state;
        const isValid = groupResponse.valid;
        const value = groupResponse.value;

        state.formInputs.newPassword = value;
        state.formInputs.newPasswordConfirmation = value;

        state.formValidation.newPassword = isValid;

        this.setState(state);
    }

    sendForm() {
        this.setState({
            btnEnabled: false,
        });

        ProfileService.updatePassword(this.state.formInputs)
            .then(() => {
                this.setState({
                    successMessage: LocaleService.t('LOGIN.SUCCESS_MESSAGE.PASSWORD_UPDATE_SUCCESS'),
                });
            })
            .catch(() => {
                this.setState({
                    errorMessage: LocaleService.t('LOGIN.ERROR_MESSAGE.UPDATE_PASSWORD_UNKNOWN_ERROR'),
                });
            })
            .then(() => {
                this.setState({
                    btnEnabled: true,
                });

                AnalyticsService.gaTrigger(TAGS.LOGIN_WIDGET__CHANGE_PASSWORD());
            });
    }

    handleFormSubmission() {
        this.setState({
            errorMessage: '',
            successMessage: '',
        });

        if (!ValidationService.validateForm(this.state.formValidation)) {
            if (!this.state.formValidation.newPassword) {
                this.setState({
                    errorMessage: LocaleService.t(CONSTANT.LOGIN_ERROR_KEY.INVALID_PASSWORD),
                });
            }
            return LocaleService.t(this.state.errorMessage);
        }

        this.sendForm();
        return LocaleService.t(this.state.successMessage);
    }

    handleSubmit(event) {
        event.preventDefault();
    }

    render() {
        return (
            <div className="passwordWrapper">
                <h2 className="sr-subtitle-2">{LocaleService.t('LOGIN.UPDATE_PASSWORD_SECTION_TITLE')}</h2>
                <form name="changePasswordForm" className="changePasswordForm" onSubmit={this.handleSubmit}>
                    <InputText
                        type="password"
                        name="currentPassword"
                        classNames={['double-third', 'styled-placeholder']}
                        value={this.state.formInputs.currentPassword}
                        label={LocaleService.t('LOGIN.PASSWORD_CHANGE.CURRENT_PASSWORD')}
                        isRequired={this.fieldRequired}
                        isValid={this.state.formValidation.currentPassword}
                        valueChange={this.handleCurrentPasswordChange}
                        minLength={FIELD_LENGTH.PASSWORD_MIN}
                        maxLength={FIELD_LENGTH.PASSWORD_MAX}
                    />

                    <PasswordGroup
                        classNames={['double-third']}
                        passwordValue={this.state.formInputs.newPassword}
                        passwordLabel={LocaleService.t('LOGIN.PASSWORD_CHANGE.NEW_PASSWORD')}
                        confirmPasswordLabel={LocaleService.t('LOGIN.PASSWORD_CHANGE.NEW_PASSWORD_CONFIRMATION')}
                        fieldRequired={this.fieldRequired}
                        valueChange={this.passwordChangeCallback}
                    />

                    <div className="error-message">{this.state.errorMessage}</div>
                    <div>{this.state.successMessage}</div>

                    <LoadingButton
                        text={LocaleService.t('LOGIN.CHANGE_PASSWORD')}
                        btnCallback={this.handleFormSubmission}
                        btnEnabled={this.state.btnEnabled}
                    />
                </form>
            </div>
        );
    }
}

ChangePasswordForm.displayName = 'ChangePasswordForm';

export default ChangePasswordForm;



// WEBPACK FOOTER //
// ./src/components/Profile/ChangePasswordForm/ChangePasswordForm.jsx